import { render, staticRenderFns } from "./roleCreat.vue?vue&type=template&id=75b29c69&scoped=true&"
import script from "./roleCreat.vue?vue&type=script&lang=js&"
export * from "./roleCreat.vue?vue&type=script&lang=js&"
import style0 from "./roleCreat.vue?vue&type=style&index=0&id=75b29c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b29c69",
  null
  
)

export default component.exports